
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DeleteIcon',

  props: {
    mimeTypeSlag: String
  }
})
